import { render, staticRenderFns } from "./DetailContainer.vue?vue&type=template&id=6687ed69"
import script from "./DetailContainer.vue?vue&type=script&lang=ts"
export * from "./DetailContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports